// extracted by css-extract-rspack-plugin
export default {"cellSub":"cellSub-m7ibmD"};